import get from "lodash/get"

import { selectData as selectJourneysData } from "redux/reducers/entities/journeys"

import {
    mapUserForMerging,
    mapRoleInvites,
    mapJourneyInvites,
    mapInviteData,
} from "redux/mappers/users/helpers"
import { USER, LOGGED_IN_USER } from "redux/reducers/entities/users/actionNames"

import { CREATE } from "redux/utility"

const mapper = {
    [USER](getState, result, originalPayload) {
        const state = getState()

        const userModel = get(result, "userModel", {})
        const userInJourneyDetail = get(result, "userInJourneyDetail", [])
        const userRoleInCompanyDetail = get(
            result,
            "userRoleInCompanyDetail",
            [],
        )
        const journeysData = selectJourneysData(state)
        const user = mapUserForMerging(
            userModel,
            userInJourneyDetail,
            userRoleInCompanyDetail,
        )

        user.invites.push(...mapRoleInvites(user.userRoleInCompanyModel))
        user.invites.push(
            ...mapJourneyInvites(user.userInJourneys, journeysData),
        )

        return { result: mapInviteData(journeysData, user), originalPayload }
    },

    [LOGGED_IN_USER](_, result, originalPayload) {
        if (!result) return { result, originalPayload }

        return {
            result: {
                ...result,
                companies: result?.companies?.map(company => ({
                    ...company,
                    roles: company?.userRoles || company?.roles,
                })),
            },
            originalPayload,
        }
    },

    [USER + CREATE](_, result, originalPayload) {
        if (!result || !originalPayload?.inviteHash) {
            return { result, originalPayload }
        }

        return {
            result: {
                ...result,
                hash: result.userHash,
                companies: result?.companies?.map(company => ({
                    ...company,
                    roles: company?.userRoles || company?.roles,
                })),
            },
            originalPayload,
        }
    },
}

export default mapper
